import { useState } from 'preact/hooks';
import Modal from './shared/Modal.jsx';
import { api } from '../state/auth.js';

// As on the website (config/club-types.js PLAN_MODULES decides what really opens)
const TIER_FEATURES = {
  plus:         ['Vergaderen & besluitenlijst', 'Welkom, overdracht & vakantievervanging', 'Rapportages & terugkerende processen', 'Storingen melden & afhandelen'],
  professional: ['Klussenbord & vacatures (met QR)', 'Kwalificaties & VOG-herinneringen', 'Visie & doelen', 'Certificering jeugdopleiding', 'Clubtrots & beloningen', 'Sportlink-koppeling', 'AI-schrijfhulp (met eigen AI-account)'],
};

// reason: 'limit' (the user limit is reached) or 'choice' (switching from the settings)
export default function SubscriptionUpgradeModal({ isOpen, onClose, currentTierLabel, nextTier, reason = 'limit' }) {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  if (!nextTier) return null;

  async function handleUpgrade() {
    setLoading(true);
    setError('');
    try {
      await api('/api/clubs/subscription', {
        method: 'PATCH',
        body: JSON.stringify({ tier: nextTier.key }),
      });
      // Menus and pages load their data per club and plan: start fresh with the new plan
      window.location.reload();
    } catch (err) {
      setError(err.detail || 'Er ging iets mis. Probeer het opnieuw.');
      setLoading(false);
    }
  }

  const features = TIER_FEATURES[nextTier.key] || [];

  return (
    <Modal isOpen={isOpen} title="Abonnement upgraden" onClose={onClose}>
      <div style="padding: 4px 0">
        <p style="color:var(--color-text-secondary);margin-bottom:20px;line-height:1.6">
          {reason === 'limit'
            ? <>Je huidige <strong>{currentTierLabel}</strong>-abonnement heeft het maximale aantal gebruikers bereikt. Upgrade naar <strong>{nextTier.label}</strong> om door te gaan.</>
            : <>Stap over van <strong>{currentTierLabel}</strong> naar <strong>{nextTier.label}</strong>. Alles van {nextTier.label} is direct beschikbaar.</>}
        </p>

        <div style="background:var(--color-bg-secondary);border:1.5px solid var(--color-border);border-radius:8px;padding:20px;margin-bottom:20px">
          <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:14px">
            <div>
              <div style="font-size:18px;font-weight:700;color:var(--color-text)">{nextTier.label}</div>
              <div style="font-size:13px;color:var(--color-text-secondary);margin-top:2px">
                {nextTier.maxUsers ? `Tot ${nextTier.maxUsers} actieve gebruikers` : 'Onbeperkt gebruikers'}
              </div>
            </div>
            <div style="text-align:right">
              <div style="font-size:24px;font-weight:700;color:var(--color-text)">€{nextTier.priceMonthly}</div>
              <div style="font-size:12px;color:var(--color-text-secondary)">/maand</div>
            </div>
          </div>
          {features.length > 0 && (
            <ul style="list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:6px">
              {features.map(f => (
                <li key={f} style="display:flex;align-items:center;gap:8px;font-size:13px;color:var(--color-text-secondary)">
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="color:var(--color-success);flex-shrink:0">
                    <polyline points="2,8 6,12 14,4"/>
                  </svg>
                  {f}
                </li>
              ))}
            </ul>
          )}
        </div>

        {error && <div class="alert alert-error mb-4">{error}</div>}

        <div style="display:flex;gap:10px;justify-content:flex-end">
          <button class="btn btn-secondary" onClick={onClose} disabled={loading}>
            Annuleren
          </button>
          <button class="btn btn-primary" onClick={handleUpgrade} disabled={loading}>
            {loading ? 'Upgraden…' : `Upgraden naar ${nextTier.label}`}
          </button>
        </div>
      </div>
    </Modal>
  );
}
